// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchBar_input__3Mb6o","button":"SearchBar_button__3ZJIN"};